import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="page container">
      <div className="empty">
        <span className="empty__emoji">🧭</span>
        <h1>{t("notFound.title")}</h1>
        <p>{t("notFound.text")}</p>
        <Link to="/" className="btn btn--primary">
          {t("notFound.cta")}
        </Link>
      </div>
    </div>
  );
}
